import { Link } from "react-router-dom";
import "../styles/cookie-policy.css";

export default function CookiePolicy() {
  return (
    <div className="cookie-policy-page">
       <div className="cookie-policy-hero">
        <div className="cookie-policy-hero__content">
          {/* <h1 className="cookie-policy-title">Cookie Policy for Ampstek</h1> */}
        </div>
      </div>
      <div className="container">
        <nav className="cookie-policy-breadcrumb">
          <Link to="/" className="cookie-policy-breadcrumb-link">Home</Link>
          <span className="cookie-policy-breadcrumb-separator">/</span>
          <span className="cookie-policy-breadcrumb-current">Cookie Policy</span>
        </nav>
      </div>

      {/* <div className="cookie-policy-hero">
        <div className="cookie-policy-hero__content">
          <h1 className="cookie-policy-title">Cookie Policy for Ampstek</h1>
        </div>
      </div> */}

      <div className="container">
        <div className="cookie-policy-content-wrapper">
          <div className="cookie-policy-content">
            <p className="cookie-policy-paragraph">
              This is the Cookie Policy for Ampstek, accessible at www.ampstek.com.
            </p>

            <h2 className="cookie-policy-heading">Understanding Cookies</h2>

            <p className="cookie-policy-paragraph">
              Like nearly all professional websites, this site utilizes cookies—small files that are downloaded to your device to enhance your browsing experience. This page outlines the information these cookies collect, their purpose, and the reasons we may need to store them. Additionally, we will explain how you can manage cookie settings, though disabling cookies may impact certain functionalities of the site.
            </p>

            <p className="cookie-policy-paragraph">
              For a broader understanding of cookies, you can refer to the <a href="https://en.wikipedia.org/wiki/HTTP_cookie" target="_blank" rel="noopener noreferrer" className="cookie-policy-link">Wikipedia article on HTTP Cookies</a>.
            </p>

            <h2 className="cookie-policy-heading">How We Utilize Cookies</h2>

            <p className="cookie-policy-paragraph">
              Cookies serve various purposes, which are detailed below. Unfortunately, there are generally no standard methods to disable cookies without also disabling the essential features they provide. It is advisable to keep all cookies enabled unless you are certain that you do not need them, as they may support services you use.
            </p>

            <h2 className="cookie-policy-heading">Managing Cookie Settings</h2>

            <p className="cookie-policy-paragraph">
              You can prevent cookies from being set by modifying your browser settings (consult your browser's Help section for guidance). Keep in mind that turning off cookies may impact the functionality of this and many other websites you visit. Typically, disabling cookies will also disable certain features of this site, so we recommend against disabling them.
            </p>

            <h2 className="cookie-policy-heading">Cookies We Use</h2>

            <h3 className="cookie-policy-subheading">Cookies Related to Forms</h3>

            <p className="cookie-policy-paragraph">
              When you fill out a form on our site, such as contact forms or comment sections, cookies may be set to remember your information for future correspondence.
            </p>

            <h3 className="cookie-policy-subheading">Third-Party Cookies</h3>

            <p className="cookie-policy-paragraph">
              In specific cases, we may also use cookies from trusted third-party providers. The following section outlines the third-party cookies you might encounter on our site.
            </p>

            <p className="cookie-policy-paragraph">
              This site employs Google Analytics, a widely recognized analytics tool that helps us understand how you interact with the site and identify areas for improvement. These cookies can track details like the duration of your visit and the pages you view, enabling us to create more engaging content.
            </p>

            <p className="cookie-policy-paragraph">
              For more information about Google Analytics cookies, please refer to the <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage" target="_blank" rel="noopener noreferrer" className="cookie-policy-link">official Google Analytics page</a>.
            </p>

            <p className="cookie-policy-paragraph">
              Occasionally, we may test new features and implement slight modifications to the site. During these tests, cookies may be utilized to ensure you receive a consistent experience and to help us understand which enhancements our users value most.
            </p>

            <h2 className="cookie-policy-heading">Further Information</h2>

            <p className="cookie-policy-paragraph">
              We hope this information has clarified your questions. As mentioned earlier, if you're unsure whether you need cookies, it's usually safer to keep them enabled in case they interact with features on our site.
            </p>

            <p className="cookie-policy-paragraph">
              If you require additional information, please feel free to contact us via one of our preferred methods:
            </p>

            <p className="cookie-policy-paragraph">
              Email: <a href="mailto:info@ampstek.com" className="cookie-policy-link">info@ampstek.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
